import { render } from "./ApproveCreateModal.vue?vue&type=template&id=765795b6&scoped=true"
import script from "./ApproveCreateModal.vue?vue&type=script&lang=js"
export * from "./ApproveCreateModal.vue?vue&type=script&lang=js"

import "./ApproveCreateModal.vue?vue&type=style&index=0&id=765795b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765795b6"]])

export default __exports__